<template>
  <div class="carousel">
    <v-carousel
      :height="height"
      :hide-delimiters="hideDelimiters"
      :hide-delimiter-background="hideDelimiterBackground"
      :show-arrows="images.length > 1"
      :class="{ 'carousel--dark': theme.isDark }"
    >
      <v-carousel-item
        v-for="image in images"
        :key="image.src"
        :src="image.src"
        eager
      >
        <div v-if="image.text" class="carousel__overlay">
          <v-container>
            <p>{{ image.text }}</p>
          </v-container>
        </div>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { useThemeHelper } from "@/theme/themeHelper"

  export type SoCarouselItem = {
    src: string
    text?: string
  }

  export default defineComponent({
    props: {
      images: {
        type: Array as PropType<SoCarouselItem[]>,
        default: () => [],
        required: true,
      },
      height: {
        type: [String, Number],
        default: 500,
      },
      hideDelimiters: {
        type: Boolean,
        default: false,
      },
      hideDelimiterBackground: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        theme: useThemeHelper(),
      }
    },
  })
</script>

<style lang="css" scoped>
  .carousel {
    height: 100%;
  }

  .carousel--dark :deep(.v-carousel__controls) {
    color: initial;
  }

  .carousel__overlay {
    background: rgba(var(--v-theme-surface-variant), 0.3);
    color: rgb(var(--v-theme-white));
  }
</style>
